import React from 'react';
import '../template-file-css/document-file-template.css';


export const LSS_IndividualStatusReport = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LSS_IndividualStatusReport' className='file-pdf-document'>
            <div className='file-template'>

                


                <h3> I.   Discussion Notes/Significant Events since Last Team Meeting (Highlight achievements or lack thereof for CM, PSR, FT, ADSS  or IN etc) :</h3>

                <p>
                    <span className="eleHeader">General Updates:</span>
                    <textarea id="txtSafety" name="txtSafety" className="add-only "></textarea>
                </p>
                <p>

                    <strong>Identify updates in any of the areas below that apply for this week:</strong>
                </p>

                <p>
                    <span className="eleHeader">1.	Safety Concerns (SI/HI):</span>
                    <textarea id="txtSafety" name="txtSafety" className="add-only "></textarea>
                </p>
                <p>
                    <span className="eleHeader">2.	Crisis:</span>
                    <textarea id="txtCrisis" name="txtCrisis" className="add-only "></textarea>
                </p>
                <p>
                    <span className="eleHeader">3.	Active Psychosis (AVH/Delusions):</span>
                    <textarea id="txtActivePsychosis" name="txtActivePsychosis" className="add-only "></textarea>
                </p>
                <p>
                    <span className="eleHeader">4.	Medication Changes:</span>
                    <textarea id="txtMedication" name="txtMedication" className="add-only "></textarea>
                </p>
                <p>
                    <span className="eleHeader">5.	Progress Statement :</span>
                    <textarea id="txtProgress" name="txtProgress" className="add-only "></textarea>
                </p>
                <h3>II.  Revisions</h3>
                <table>
                    <tr>
                        <td className='w-450'>TREATMENT PLAN UPDATE NEEDED </td>
                        <td className='w-100'><center>
                            <input type="radio" id="rbRevisionsYes_1" name="rbRevisions_1" className='add-only' value="yes" /> Yes </center>
                        </td>
                        <td className='w-100'><center>
                            <input type="radio" id="rbRevisionsNo_1" name="rbRevisions_1" className='add-only' value="No" />  No</center>
                        </td>
                        <td className='w-100'><center>
                            <input type="radio" id="rbRevisionsNa_1" name="rbRevisions_1" className='add-only' value="NA" /> N/A</center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>ReAUTHORIZATION NEEDED </td>
                        <td className='w-100'><center>
                            <input type="radio" id="rbRevisionsYes_2" name="rbRevisions_2" className='add-only' value="yes" /> Yes </center>
                        </td>
                        <td className='w-100'><center>
                            <input type="radio" id="rbRevisionsNo_2" name="rbRevisions_2" className='add-only' value="No" />  No</center>
                        </td>
                        <td className='w-100'><center>
                            <input type="radio" id="rbRevisionsNa_2" name="rbRevisions_2" className='add-only' value="NA" /> N/A </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>REQUEST FOR DISCHARGE</td>
                        <td className='w-100'><center>
                            <input type="radio" id="rbRevisionsYes_3" name="rbRevisions_3" className='add-only' value="yes" /> Yes </center>
                        </td>
                        <td className='w-100'><center>
                            <input type="radio" id="rbRevisionsNo_3" name="rbRevisions_3" className='add-only' value="No" />  No</center>
                        </td>
                        <td className='w-100'><center>
                            <input type="radio" id="rbRevisionsNa_3" name="rbRevisions_3" className='add-only' value="NA" /> N/A </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>REQUEST FOR HIGHER LEVEL OF CARE</td>
                        <td className='w-100'><center>
                            <input type="radio" id="rbRevisionsYes_4" name="rbRevisions_4" className='add-only' value="yes" /> Yes </center>
                        </td>
                        <td className='w-100'><center>
                            <input type="radio" id="rbRevisionsNo_4" name="rbRevisions_4" className='add-only' value="No" />  No</center>
                        </td>
                        <td className='w-100'><center>
                            <input type="radio" id="rbRevisionsNa_4" name="rbRevisions_4" className='add-only' value="NA" /> N/A </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>REQUEST FOR LOWER LEVEL OF CARE</td>
                        <td className='w-100'><center>
                            <input type="radio" id="rbRevisionsYes_5" name="rbRevisions_5" className='add-only' value="yes" /> Yes </center>
                        </td>
                        <td className='w-100'><center>
                            <input type="radio" id="rbRevisionsNo_5" name="rbRevisions_5" className='add-only' value="No" /> No </center>
                        </td>
                        <td className='w-100'><center>
                            <input type="radio" id="rbRevisionsNa_5" name="rbRevisions_5" className='add-only' value="NA" /> N/A </center>
                        </td>
                    </tr>
                </table>
                <h3>III.  PLEASE CHECK THE FOLLOWING FOR LINKAGES COMPLETED AND DOCUMENTED IN THE LAST TWO WEEKS:</h3>

                <table>


                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_LINKAGES_AND_DOCUMENTED_1" name="cb_LINKAGES_AND_DOCUMENTED_1" className='add-only' value="LINKAGES_AND_DOCUMENTED_1" />BIRTH CERTIFICATE
                        </td>

                        <td className='w-250'>
                            <input type="checkbox" id="cb_LINKAGES_AND_DOCUMENTED_2" name="cb_LINKAGES_AND_DOCUMENTED_2" className='add-only' value="LINKAGES_AND_DOCUMENTED_2" />UTILITY RESOURCES
                        </td>

                        <td className='w-250'>
                            <input type="checkbox" id="cb_LINKAGES_AND_DOCUMENTED_3" name="cb_LINKAGES_AND_DOCUMENTED_3" className='add-only' value="LINKAGES_AND_DOCUMENTED_3" />MEDICAL ATTENTION (IE. PCP)
                        </td>

                    </tr>


                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_LINKAGES_AND_DOCUMENTED_4" name="cb_LINKAGES_AND_DOCUMENTED_4" className='add-only' value="LINKAGES_AND_DOCUMENTED_4" />IDENTIFICATION
                        </td>

                        <td className='w-250'>
                            <input type="checkbox" id="cb_LINKAGES_AND_DOCUMENTED_5" name="cb_LINKAGES_AND_DOCUMENTED_5" className='add-only' value="LINKAGES_AND_DOCUMENTED_5" />CHURCH
                        </td>

                        <td className='w-250'>
                            <input type="checkbox" id="cb_LINKAGES_AND_DOCUMENTED_6" name="cb_LINKAGES_AND_DOCUMENTED_6" className='add-only' value="LINKAGES_AND_DOCUMENTED_6" />PROBATION
                        </td>

                    </tr>


                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_LINKAGES_AND_DOCUMENTED_7" name="cb_LINKAGES_AND_DOCUMENTED_7" className='add-only' value="LINKAGES_AND_DOCUMENTED_7" />FOOD RESOURCES
                        </td>

                        <td className='w-250'>
                            <input type="checkbox" id="cb_LINKAGES_AND_DOCUMENTED_8" name="cb_LINKAGES_AND_DOCUMENTED_8" className='add-only' value="LINKAGES_AND_DOCUMENTED_8" />COMMUNITY PROGRAMS
                        </td>

                        <td className='w-250'>
                            <input type="checkbox" id="cb_LINKAGES_AND_DOCUMENTED_9" name="cb_LINKAGES_AND_DOCUMENTED_9" className='add-only' value="LINKAGES_AND_DOCUMENTED_9" />APS REPORT COMPLETED
                        </td>

                    </tr>


                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_LINKAGES_AND_DOCUMENTED_10" name="cb_LINKAGES_AND_DOCUMENTED_10" className='add-only' value="LINKAGES_AND_DOCUMENTED_10" />CLOTHING RESOURCES
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_LINKAGES_AND_DOCUMENTED_11" name="cb_LINKAGES_AND_DOCUMENTED_11" className='add-only' value="LINKAGES_AND_DOCUMENTED_11" />INDIVIDUALS RIGHTS GROUPS
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_LINKAGES_AND_DOCUMENTED_12" name="cb_LINKAGES_AND_DOCUMENTED_12" className='add-only' value="LINKAGES_AND_DOCUMENTED_12" />DFCS REPORT COMPLETED
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_LINKAGES_AND_DOCUMENTED_13" name="cb_LINKAGES_AND_DOCUMENTED_13" className='add-only' value="LINKAGES_AND_DOCUMENTED_13" />HOUSING RESOURCES
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_LINKAGES_AND_DOCUMENTED_14" name="cb_LINKAGES_AND_DOCUMENTED_14" className='add-only' value="LINKAGES_AND_DOCUMENTED_14" />AA/NA GROUPS
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cb_LINKAGES_AND_DOCUMENTED_15" name="cb_LINKAGES_AND_DOCUMENTED_15" className='add-only' value="LINKAGES_AND_DOCUMENTED_15" />OTHER
                        </td>
                    </tr>

                </table>
                <p>
                    <strong>Please provide details of any items checked above:</strong>
                    <textarea id="txtItemsChecked" name="txtItemsChecked" className='add-only'></textarea>

                </p>
                <h3>IV.  Team Recommendations:</h3>
                <p>
                    <textarea id="txtTeamRecommendations" name="txtTeamRecommendations" className='add-only'></textarea>

                </p>
                <h3>V.  Update Individual information:</h3>
                <p>
                    <span className='small'>Change of address/phone number:</span>
                    <textarea id="txtIndividualInformation_1" name="txtIndividualInformation_1" className='add-only'></textarea>
                </p>

                <p>

                    <span className='eleHeader'>Updated PCP/Dentist or Psychiatric Information (name, address, phone and fax):</span>
                    <textarea id="txtIndividualInformation_2" name="txtIndividualInformation_2" className='add-only'></textarea>
                </p>
            </div>
        </form >

    )
}